export { MenuItemIconSwitch } from './MenuItemIconSwitch'
export type { MaterialIcon } from './MenuItemIconSwitch'
